import { toast } from "sonner";
import { genreKey } from "@/lib/music/meta";

export const EMPTY_MIX = { genres: [], moods: [] };

export const mixTracks = (m, { genres, moods }) => {
  if (!genres.length && !moods.length) return [];
  const g = new Set(genres);
  return m.tracks.filter((t) => (!g.size || g.has(genreKey(t))) && (!moods.length || moods.some((x) => m.moods[t.path]?.includes(x))));
};

const join = (names) => `${names.slice(0, 3).join(" + ")}${names.length > 3 ? ` +${names.length - 3}` : ""}`;

export const mixName = (m, { genres, moods }) => {
  const g = genres.map((k) => m.genres.find((x) => x.key === k)?.name).filter(Boolean);
  const parts = [moods.length && join(moods), g.length && join(g)].filter(Boolean);
  return parts.length ? `${parts.join(" · ")} mix` : "Mix";
};

export const toggleIn = (mix, kind, v) => ({ ...mix, [kind]: mix[kind].includes(v) ? mix[kind].filter((x) => x !== v) : [...mix[kind], v] });

export const moodCounts = (m) => {
  const c = {};
  Object.values(m.moods).forEach((list) => list.forEach((x) => { c[x] = (c[x] || 0) + 1; }));
  return m.allMoods.filter((x) => c[x]).map((name) => ({ name, count: c[name] }));
};

export const saveMix = (m, mix) => {
  const paths = mixTracks(m, mix).map((t) => t.path);
  if (!paths.length) return null;
  const p = m.pl.create(mixName(m, mix), paths);
  toast.success(`Saved ${paths.length.toLocaleString()} ${paths.length === 1 ? "song" : "songs"} as “${p.name}”`);
  return p;
};
